import { Controller } from '@hotwired/stimulus';
import debounce from "lodash/debounce";

export default class extends Controller {
  static targets = ['input'];
  static values = {
    source: String,
    clazz: String,
    persisted: String
  };

  initialize() {
    this.debouncedLookup = debounce(this.performLookup.bind(this), 300);
  }

  lookup() {
    this.debouncedLookup();
  }

  performLookup() {
    const zipcode = this.inputTarget.value.trim();

    // If the input is empty, dispatch an event to clear the marker from the map
    if (!zipcode) {
      this.clearMarkerFromMap();
      return;
    }

    fetch(`/manage/zipcodes/${encodeURIComponent(zipcode)}`)
      .then(response => {
        if (!response.ok) throw new Error('Zipcode not found');
        return response.json();
      })
      .then(data => {
        document.dispatchEvent(
          new CustomEvent('zipcode:loaded', {
            detail: {
              ...data,
              clazz: this.clazzValue,
              clazz_id: this.sourceValue,
              persisted: this.persistedValue === 'true'
            }
          })
        );
      })
      .catch(error => {
        console.log(error);
      });
  }

  clearMarkerFromMap() {
    document.dispatchEvent(
      new CustomEvent('zipcode:cleared', {
        detail: {
          clazz: this.clazzValue,
          clazz_id: this.sourceValue,
          persisted: this.persistedValue === 'true'
        }
      })
    );
  }
}
